import { observer } from 'mobx-react-lite';
import { Button, Header, Segment } from 'semantic-ui-react';
import { User } from '../../../app/models/user';
import { useStore } from '../../../app/stores/store';
import RegisterForm from '../../user/RegisterForm';
import  PermitHolderContainerContent from '../common/PermitHolderContainerContent';

interface Props {
    user: User
}

export default observer(function PermitDashboardPermitHolderContent({ 
    user
}: Props) {
    const {modalStore} = useStore();
    const {openModal} = modalStore;
    
    return (
        <Segment>
            <Header 
                as='h2' 
                dividing 
                content='Account Info' 
                color='teal' 
                floated='left' 
            />
            <Button
                floated='right'
                onClick={() => openModal(<RegisterForm isRedirect={true} />)} 
                content='Edit'
                size='tiny'
            />

            <PermitHolderContainerContent user={user!} />
        </Segment>
    )
})